module.exports = __webpack_public_path__ + "img/td.0c3474e4.jpg";